<script setup lang="ts">
import { storeToRefs } from 'pinia';

import ottoFloating from '@clovyr/bed/assets/images/otto-floating.svg';
import ImageMedia from '@clovyr/bed/components/media/ImageMedia.vue';

import Module from '@/components/elements/Module.vue';
import GardenIcon from '@/components/icons/GardenIcon.vue';
import LibraryIcon from '@/components/icons/LibraryIcon.vue';
import { usePollenStore } from '@/stores/pollen_store';
import AccountLoggedOut from '@/views/Settings/AccountLoggedOut.vue';

const props = defineProps<{
  showClose?: boolean;
  moduleId?: string;
}>();

const pollenStore = usePollenStore();
const { isUserAuthenticated } = storeToRefs(pollenStore);
</script>

<template>
  <!-- module: welcome -->
  <Module
    :show-close="props.showClose"
    :module-id="props.moduleId"
    class="welcome"
    bigHead
    hed="Welcome to Clovyr!"
    dek="One home for all your self-hosted applications, no matter where they run. Take a look at the left-hand sidebar to find permanent links to the Clovyr Garden, your Library of apps, Account settings, and more."
  >
    <template #heading>
      <ImageMedia :filename="ottoFloating" />
    </template>

    <template #default v-if="!isUserAuthenticated">
      <div class="section-1">
        <div class="row module__blurb__body">Create an Account</div>
        <div class="row">
          To synchronize your account data and enable access from multiple devices, create a Clovyr
          account.
        </div>
      </div>

      <div class="row">
        <div class="grid__col-md-6"></div>
        <div class="hosting-heading__button grid__col-md-6">
          <AccountLoggedOut
            :display-plain-button="true"
            :is-user-authenticated="isUserAuthenticated"
          />
        </div>
      </div>
    </template>

    <template #default2>
      <div class="links">Helpful links:</div>
      <div class="row">
        <div class="grid__col">
          <div class="module__blurb">
            <div class="module__blurb__head">
              <router-link to="/" class="module__blurb__head__inner">
                The Garden
                <GardenIcon />
              </router-link>
            </div>
            <div class="module__blurb__body">
              The app marketplace. Find new apps that treat you better.
            </div>
          </div>
        </div>
        <div class="grid__col">
          <div class="module__blurb">
            <div class="module__blurb__head">
              <router-link to="/library" class="module__blurb__head__inner">
                My Library
                <LibraryIcon />
              </router-link>
            </div>
            <div class="module__blurb__body">
              Where you access and manage all of your launched applications.
            </div>
          </div>
        </div>
      </div>
    </template>
  </Module>
</template>
